export const hospitalCodeToName: Record<string, string> = {
  A1300001: "영남대학교병원",
  A1300002: "경북대학교병원",
  A1300003: "계명대학교동산병원",
  A1300004: "대구가톨릭대학교병원",
  A1300007: "대구의료원",
  A1300010: "칠곡경북대학교병원",
  A1303386: "계명대학교대구동산병원",
  A1300009: "대구파티마병원",
  A1300008: "곽병원",
  A1300034: "드림종합병원",
  A1300076: "대구굿모닝병원",
  A1300005: "대구가톨릭대학교칠곡가톨릭병원",
  A1300081: "(재)미리내천주성삼성직수도회천주성삼병원",
  A1300011: "한국보훈복지의료공단대구보훈병원",
  A1300045: "삼일병원",
  A1300110: "더블유병원",
  A1300006: "의료법인구의료재단구병원",
  A1300038: "나사렛종합병원",
  A1300018: "강남종합병원",
};

export const hospitalNameToShort: Record<string, string> = {
  영남대학교병원: "영남대학교병원",
  경북대학교병원: "경북대학교병원",
  계명대학교동산병원: "계명대동산병원",
  대구가톨릭대학교병원: "대가대병원",
  대구의료원: "대구의료원",
  칠곡경북대학교병원: "칠곡경대병원",
  계명대학교대구동산병원: "계명대대구동산병원",
  대구파티마병원: "대구파티마병원",
  곽병원: "곽병원",
  드림종합병원: "드림종합병원",
  대구굿모닝병원: "대구굿모닝병원",
  대구가톨릭대학교칠곡가톨릭병원: "대가대칠곡가톨릭병원",
  미리내천주성삼성직수도회천주성삼병원: "천주성삼병원",
  한국보훈복지의료공단대구보훈병원: "대구보훈병원",
  삼일병원: "삼일병원",
  더블유병원: "더블유병원",
  의료법인구의료재단구병원: "구병원",
  나사렛종합병원: "나사렛종합병원",
  강남종합병원: "강남종합병원",
};
